module.exports = __webpack_public_path__ + "img/tools-dex.9f600da0.png";